import { create } from "zustand";
import { persist } from "zustand/middleware";

interface FirstStepsState {
  isDismissed: boolean;
  checkedItems: string[];
  dismiss: () => void;
  toggleItem: (itemId: string) => void;
}

export const useFirstStepsStore = create<FirstStepsState>()(
  persist(
    (set) => ({
      isDismissed: false,
      checkedItems: [],
      dismiss: () => set({ isDismissed: true }),
      toggleItem: (itemId: string) =>
        set((state) => ({
          checkedItems: state.checkedItems.includes(itemId)
            ? state.checkedItems.filter((id) => id !== itemId)
            : [...state.checkedItems, itemId],
        })),
    }),
    {
      name: "sky-first-steps",
      partialize: (state) => ({
        isDismissed: state.isDismissed,
        checkedItems: state.checkedItems,
      }),
    }
  )
);
